var microServiceDev = {
    userService: "userserviceapidev/api/",
    dashboardService: "dashboardserviceapidev/api/",
    leadService: "leadserviceapidev/api/",
    masterSevice: "masterserviceapidev/api/",
    casAdvisoryService: "casadvisoryservicedev/api/",
    downloadreportservice: "downloadreportservice/api/",
    investmentService: "investmentserviceapidev/api/",
    otcService: "otcserviceapi/api/",
};
export var microServiceUat = {
    userService: "userserviceapi/api/",
    dashboardService: "dashboardserviceapi/api/",
    leadService: "leadserviceapi/api/",
    masterSevice: "masterserviceapi/api/",
    casAdvisoryService: "casadvisoryservice/api/",
    AOPOBSERVICE: "AOPOBSERVICE/api/",
    investmentService: "investmentserviceapi/api/",
    otcService: "otcserviceapi/api/",
};
// docker uat -- Rohit J
// const microServiceUat = {
//   userService: "userservice/api/",
//   dashboardService: "dashboardservice/api/",
//   leadService: "leadservice/api/",
//   masterSevice: "masterservice/api/",
//   downloadreportservice: "downloadreportservice/api/",
// };
// const microServiceCug = {
//   userService: "userservice/api/",
//   dashboardService: "dashboardservice/api/",
//   leadService: "leadservice/api/",
//   masterSevice: "masterservice/api/",
// };
// cug microService base
var microServiceCug = {
    userService: "userservicecug/api/",
    dashboardService: "dashboardservicecug/api/",
    leadService: "leadservicecug/api/",
    masterSevice: "masterservicecug/api/",
    casAdvisoryService: "casadvisoryservicecug/api/",
    downloadreportservice: "downloadreportservice/api/",
    AOPOBSERVICE: "AOPOBSERVICE/api/",
    investmentService: "investmentservicecug/api/",
    otcService: "otcservicecug/api/",
};
var microServiceProd = {
    userService: "userservice/api/",
    dashboardService: "dashboardservice/api/",
    leadService: "leadservice/api/",
    masterSevice: "masterservice/api/",
    casAdvisoryService: "casadvisoryservice/api/",
    downloadreportservice: "downloadreportservice/api/",
    AOPOBSERVICE: "aopserviceprod/api/",
    investmentService: "investmentserviceprod/api/",
    otcService: "otcserviceprod/api/",
};
export var microService = process.env.NODE_ENV === "production"
    ? microServiceProd
    : process.env.NODE_ENV === "cug"
        ? microServiceCug
        : process.env.NODE_ENV === "uat"
            ? microServiceUat
            : microServiceUat;
